import Waiting from '@/store/waiting';

export default class AvailableFeatureActions {
  constructor (Api, types) {
    const actions = {
      async getAvailableFeaturesAction ({ commit }, args) {
        await waiting.check('getAvailableFeaturesAction', async () => {
          try {
            const res = await Api.getAvailableFeatures(args);
            commit(types.SET_AVAILABLE_FEATURES, Object.values(res.data)[0]);
          } catch (err) {
            throw err;
          }
        });
      },
    };
    const waiting = new Waiting(actions);
    this.actions = actions;
  }
}
